import { Country } from '@/shared/api';
import { ICountry } from '@/shared/lib';
import { SelectOption } from '@/shared/ui';

import { serializeCountry } from './serialize-country';

export const serializeCountrySelect = (
  country: Country,
): SelectOption<ICountry> => ({
  value: country.id,
  label: country.item?.name ?? country.alpha3,
  option: serializeCountry(country),
});
